import React, { useContext } from 'react';
import GdsClient, { EventBody, EventResponse, GuestWeddingResponse } from '../../../../gds-api-client';
import { DeleteConfirmation as DeleteScreen, RouterContext } from '../../../../gs-component-right-rail';
import get from 'lodash/get';
import { GuestWedding } from '../../../GuestWeddingTypes';
import { Household } from '../../../HouseholdTypes';
import { trackQuestionInteraction } from '../../../helpers/analytics';

import { Values, EventType } from '../../../EventTypes';

interface Props {
  event: EventType | null;
  values: Values;
  guestWedding: GuestWedding;
  households: Household[];
  onClose: () => void;
  onSuccess: (data: GuestWeddingResponse, variant?: string) => void;
  onEventsUpdate: (events: EventResponse[]) => void;
  client: GdsClient;
  isGeneralQuestion: boolean;
}

const haveWeReceivedAnswers = (households: Household[]): boolean => {
  for (let i = 0; i < households.length; i += 1) {
    const household = households[i];
    if (household.answers && household.answers.length) {
      return true;
    }
    const people = household.people || [];
    for (let j = 0; j < people.length; j += 1) {
      const person = people[j];
      if (person.answers && person.answers.length) {
        return true;
      }

      const invitations = person.invitations || [];
      for (let k = 0; k < invitations.length; k += 1) {
        const invitation = invitations[k];
        if (invitation.answers && invitation.answers.length) {
          return true;
        }
      }
    }
  }

  return false;
};

const DeleteConfirmation: React.FC<Props> = ({
  onSuccess,
  event,
  guestWedding,
  onEventsUpdate,
  values,
  onClose,
  client,
  households,
  isGeneralQuestion,
}) => {
  const { goBack } = useContext(RouterContext);
  const questionsHaveAnswers = haveWeReceivedAnswers(households);
  let message = 'This will permanently remove the question';

  if ((get(event, ['requireRsvp']) && questionsHaveAnswers) || (!event && questionsHaveAnswers)) {
    message = 'This will permanently delete the question and any answers you’ve already received.';
  }

  const deleteQuestion = async (): Promise<void> => {
    const formQuestion = values;
    let updatedQuestions: any = [];

    if (isGeneralQuestion) {
      updatedQuestions = guestWedding.questions?.filter(q => q.id !== formQuestion.id);
      const { data: cerRes } = await client.updateGuestWedding({
        questions: updatedQuestions,
      });

      if (!cerRes.questions) {
        cerRes.questions = [];
      }

      onSuccess(cerRes);
    } else if (event) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { guestCount, ...putableEvent } = event;
      updatedQuestions = event.questions?.filter(q => q.id !== formQuestion.id);
      const { data: cerRes } = await client.putEvent(event.id, {
        ...(putableEvent as EventBody),
        questions: updatedQuestions,
      });

      onEventsUpdate([cerRes]);
    }
    trackQuestionInteraction({
      selection: 'delete question',
      question: values,
      isGeneralQuestion,
    });
    onClose();
  };

  return <DeleteScreen onDelete={deleteQuestion} onCancel={goBack} info={message} />;
};

export default DeleteConfirmation;
